import axios from "axios";

export const postApi = async (url, body, headers, params) =>{
    return axios.post(`https://ill-ruby-shark-fez.cyclic.app/${url}`, body, {
      params: { ...params },
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        ...headers
      }
});}